import { ArchiveEntry } from 'src/api/endpoints/materials/files/api'
import { NewFile, UpdateFile } from 'src/api/endpoints/materials'
import { filter, map } from 'lodash'

export const generateFile = (entry: ArchiveEntry): File => {
    return new File([new ArrayBuffer(entry.size)], entry.filename, { lastModified: 0 }) // пустые файлы с lastModified : 0
}

export const generateFiles = (entries: ArchiveEntry[]): File[] => {
    return map(entries, generateFile)
}

export const serializeFiles = async (
    files: File[] | null | undefined,
): Promise<UpdateFile> => {
    files = files ?? []
    
    if (!files.length)
        return { news: [], old: [] }
    
    const old: string[] = map(
        filter(files, (file: File): boolean => file.lastModified === 0),
        (file: File): string => file.name,
    )
    
    return Promise.all(
        map(
            filter(files, (file: File): boolean => file.lastModified !== 0),
            (file: File): Promise<NewFile> =>
                file.arrayBuffer().then((result: ArrayBuffer) => ({
                    content: Array.from(new Uint8Array(result)),
                    name: file.name,
                })),
        ),
    ).then((convertedFiles: NewFile[]): UpdateFile => {
        return {
            news: convertedFiles,
            old,
        }
    })
}